import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { useDataGrid } from "hooks/useDataGrid";
import { useContext, useState } from "react";
import { GlobalContext } from "store/globalContext";
import { AccessDetailsDialog } from "./AccessDetailsDialog";
import { displayCreatedAt } from "utils/helpers";

const columns = [
  {
    label: "ID",
    field: "id",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: ({ id }) => <TextFieldWithEllipsis>{id}</TextFieldWithEllipsis>,
  },
  {
    label: "Created At",
    field: "createdAt",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: displayCreatedAt,
  },
  {
    label: "Description",
    field: "description",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ description }) => (
      <TextFieldWithEllipsis>{description}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "IP",
    field: "sourceIp",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ sourceIp }) => (
      <TextFieldWithEllipsis>{sourceIp}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "User Name",
    field: "userName",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ userName }) => (
      <TextFieldWithEllipsis>{userName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Email",
    field: "userEmail",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: ({ userEmail }) => (
      <TextFieldWithEllipsis>{userEmail}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "userPhone",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ userPhone }) => (
      <TextFieldWithEllipsis>{userPhone}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Button Id",
    field: "buttonId",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ buttonId }) => (
      <TextFieldWithEllipsis>{buttonId}</TextFieldWithEllipsis>
    ),
  },
];

const mobileColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 3.5,
    sm: 3.5,
    md: 3.5,
    renderer: displayCreatedAt,
  },
  {
    label: "Description",
    field: "description",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ description }) => (
      <TextFieldWithEllipsis>{description}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "IP",
    field: "sourceIp",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: ({ sourceIp }) => (
      <TextFieldWithEllipsis>{sourceIp}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Email",
    field: "userEmail",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ userEmail }) => (
      <TextFieldWithEllipsis>{userEmail}</TextFieldWithEllipsis>
    ),
  },
];

export const AccessLogs = () => {
  const [selectedRow, setSelectedRow] = useState({});
  const { userData } = useContext(GlobalContext);

  const dataGrid = useDataGrid({
    url: "/users/logs",
    defaultSorter: {
      name: "id",
      order: "desc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Users-logs`,
    reloadIntervalInSeconds: 60,
  });

  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  return (
    <CommonOutletTemplate title="Access Logs" isLoading={!dataGrid?.rows}>
      <DataGrid
        columns={columns}
        mobileColumns={mobileColumns}
        handleRowClick={handleRowClick}
        withRefreshButton
        {...dataGrid}
      />
      {
        // @ts-ignore
        selectedRow?.id && (
          <AccessDetailsDialog
            selectedRow={selectedRow}
            handleClose={() => setSelectedRow({})}
          />
        )
      }
    </CommonOutletTemplate>
  );
};
